import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteDestinationById, deletePopularDestinationById, fetchPopularDestinationList } from '../../services/userservice';

// Thunk to fetch destinations and save to session storage
export const fetchPopularDestinations = createAsyncThunk(
    'populardestination/fetch',
    async (_, { rejectWithValue }) => {
        try {
            console.log("Fetching popular destinations...");
            const response = await fetchPopularDestinationList();
            return response.data?.data;
        } catch (error) {
            console.error("Fetch error:", error.message);
            return rejectWithValue(error.message);
        }
    }
);

// Thunk to delete a destination
export const deleteDestination = createAsyncThunk(
    'populardestination/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await deletePopularDestinationById(id);
            if (response.status === 200 || response.status === 204) {
                return id;
            } else {
                return rejectWithValue("Failed to delete destination.");
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const popularDestinationsSlice = createSlice({
    name: 'populardestination',
    initialState: {
        destinations: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPopularDestinations.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPopularDestinations.fulfilled, (state, action) => {
                console.log("Fetch successful, payload:", action.payload);
                state.destinations = action.payload;
                state.loading = false;
            })
            .addCase(fetchPopularDestinations.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Delete destination
            .addCase(deleteDestination.fulfilled, (state, action) => {
                console.log("Delete successful, id:", action.payload);
                state.destinations = state.destinations.filter(
                    (destination) => destination.id !== action.payload
                );
                // Update session storage after delete
                sessionStorage.setItem('popularDestinations', JSON.stringify(state.destinations));
            })
            .addCase(deleteDestination.rejected, (state, action) => {
                console.log("Delete failed, error:", action.payload);
                state.error = action.payload;
            });
    },
});

export default popularDestinationsSlice.reducer;
